const authorizedDealer = {
  authorizedDealer: {
    dealerId: 'Bevoegde onderaannemer',
    city: 'Plaats',
    state: 'Staat',
    country: 'Land',
    noDealer: '** Geen bevoegde onderaannemer beschikbaar **',
    heading: 'Bevoegde onderaannemer',
    addDealerButton: '+ Bevoegde onderaannemer toevoegen',
    cancel: 'ANNULEREN',
    addSubcontractor: 'ONDERAANNEMER TOEVOEGEN',
    searchContractor: 'ONDERAANNEMER ZOEKEN',
    show: 'Weergeven',
    to: 'naar',
    of: 'van',
    delete: 'Verwijderen',
    name: 'Naam',
    enabled: 'Ingeschakeld',
    disabled: 'Uitgeschakeld',
    status: 'Status',
    footer: 'Bevoegde onderaannemers'
  }
};

export default authorizedDealer;
